import React from "react";
import PropTypes from "prop-types";
import { ucFirst } from "~/utils";

const ListIntegrationBidang = ({
  name,
  count,
  onDelete,
  isPenguasa,
  ...rest
}) => {
  return (
    <>
      <div className="px-2 mb-3" style={{ width: "100%", height: "auto" }}>
        <div className="d-flex align-items-center mb-2">
          <div
            className="bg-info text-white d-flex align-items-center justify-content-center"
            style={{
              width: "25px",
              height: "25px",
              fontSize: ".7rem",
              borderRadius: "100%",
            }}
          >
            {count}.
          </div>
          <div className="ml-2">{name?.toUpperCase()}</div>
          <div className="ml-auto">
            <span
              title="Hapus"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              className="btn btn-sm btn-danger text-white d-flex align-items-center justify-content-center mr-1"
              style={{ width: "30px", height: "30px", borderRadius: "100%" }}
              onClick={onDelete}
            >
              <i className="mdi mdi-delete" />
            </span>
          </div>
        </div>
        {!isPenguasa && (
          <div className="d-flex" style={{ width: "100%" }}>
            <input
              type="number"
              className="form-control"
              placeholder="Bidang Ke"
              {...rest}
            />
          </div>
        )}
      </div>
      <hr />
    </>
  );
};

ListIntegrationBidang.propTypes = {
  name: PropTypes.string,
  count: PropTypes.number,
  onDelete: PropTypes.func,
  isPenguasa: PropTypes.bool,
};

export default ListIntegrationBidang;
